/**
 * @generated SignedSource<<7fffcd03605f06eaa5873ef7f1b6e834>>
 * @relayHash 4f476a3269c073f4aafe9312d2678410
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 582c84182b144e5c8671f00e32dff74f395b90bc152ef8e392d65273837f95cf

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOTimeGranularity = "DAY" | "FIFTEEN_MINUTES" | "HOUR" | "MINUTES_15" | "MONTH" | "WEEK" | "%future added value";
export type PerformanceOverviewQuery$variables = {
  cloudId: string;
  endDate: AGG$DateTime;
  granularity?: JiraCFOTimeGranularity | null;
  startDate: AGG$DateTime;
};
export type PerformanceOverviewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewCharts" | "PerformanceOverviewRecommendations">;
};
export type PerformanceOverviewQuery = {
  response: PerformanceOverviewQuery$data;
  variables: PerformanceOverviewQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider": issueViewValues_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcenablecforecommendationsm1relayprovider": enableCFORecommendationsM1_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcenablecforecommendationsm1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider: {
    readonly get: () => ReadonlyArray<string>;
  };
});

import enableCFORecommendationsM1_provider from '@jira/platform__graphql-relay-provider/src/enable-cfo-recommendations-m1.relayprovider';
import issueViewValues_provider from '@jira/platform__graphql-relay-provider/src/ttvc-dimensions-issue-view-relay-provider.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": "DAY",
  "kind": "LocalArgument",
  "name": "granularity"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v6 = {
  "kind": "Variable",
  "name": "granularity",
  "variableName": "granularity"
},
v7 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v8 = [
  (v4/*: any*/)
],
v9 = {
  "kind": "Literal",
  "name": "dimensions",
  "value": ([]/*: any*/)
},
v10 = {
  "kind": "Literal",
  "name": "metrics",
  "value": [
    {
      "aggregation": {
        "type": "PERCENTILE",
        "value": 0.75
      },
      "alias": "p75",
      "name": "ttvc90"
    },
    {
      "aggregation": {
        "type": "PERCENTILE",
        "value": 0.5
      },
      "alias": "p50",
      "name": "ttvc90",
      "summarize": true
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v13 = [
  (v11/*: any*/),
  {
    "concreteType": "JiraCFODataRowConnection",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraCFODataRowEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "timestamp"
              },
              {
                "concreteType": "JiraCFOMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": (v12/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "name": "summary",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      {
        "concreteType": "JiraCFOMetricComparison",
        "kind": "LinkedField",
        "name": "periodComparison",
        "plural": true,
        "selections": [
          {
            "concreteType": "JiraCFOMetric",
            "kind": "LinkedField",
            "name": "currentPeriod",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "kind": "ScalarField",
            "name": "change"
          }
        ]
      }
    ]
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "projectsOverLimit"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PerformanceOverviewQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PerformanceOverviewCharts"
      },
      {
        "args": (v8/*: any*/),
        "kind": "FragmentSpread",
        "name": "PerformanceOverviewRecommendations"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcenablecforecommendationsm1relayprovider"
      }
    ],
    "kind": "Operation",
    "name": "PerformanceOverviewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "allExperiences",
            "args": [
              (v4/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v13/*: any*/)
          },
          {
            "alias": "boards",
            "args": [
              (v4/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "filters",
                "value": [
                  {
                    "dimensionFilter": {
                      "name": "experience",
                      "operator": "IN",
                      "values": [
                        "Classic Board",
                        "Nextgen Board"
                      ]
                    }
                  }
                ]
              },
              (v6/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v13/*: any*/)
          },
          {
            "alias": "workItems",
            "args": [
              (v4/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/),
              {
                "items": [
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "experience"
                          },
                          {
                            "kind": "Literal",
                            "name": "operator",
                            "value": "IN"
                          },
                          {
                            "kind": "Variable",
                            "name": "values",
                            "variableName": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "dimensionFilter"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filters.0"
                  }
                ],
                "kind": "ListValue",
                "name": "filters"
              },
              (v6/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v13/*: any*/)
          },
          {
            "alias": "backlogs",
            "args": [
              (v4/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "filters",
                "value": [
                  {
                    "dimensionFilter": {
                      "name": "experience",
                      "operator": "IN",
                      "values": [
                        "Classic Backlog",
                        "Nextgen Backlog"
                      ]
                    }
                  }
                ]
              },
              (v6/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v13/*: any*/)
          }
        ]
      },
      {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcenablecforecommendationsm1relayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraResourceUsageMetricConnectionV2",
                "kind": "LinkedField",
                "name": "resourceUsageMetricsV2",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "unusedCustomFieldsCount"
                          }
                        ],
                        "type": "JiraCustomFieldUsageMetric"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/)
                        ],
                        "type": "JiraWorkTypeUsageMetric"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "582c84182b144e5c8671f00e32dff74f395b90bc152ef8e392d65273837f95cf",
    "metadata": {},
    "name": "PerformanceOverviewQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcttvcdimensionsissueviewrelayproviderrelayprovider": issueViewValues_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcenablecforecommendationsm1relayprovider": enableCFORecommendationsM1_provider
    }
  }
};
})();

(node as any).hash = "881c8d46154125448c6f0461f1adf8cd";

export default node;
